import React from 'react';
import { Link } from 'react-router-dom';
import './ProfileCard.css';

interface ProfileCardProps {
  name: string;
  image: string;
  to: string;
  state?: any;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ name, image, to, state }) => {
  return (
    <Link to={to} state={state} className="profile-card">
      <div className="image-container">
        <img src={image} alt={`${name} profile`} className="profile-image" loading="lazy" decoding="async" />
      </div>
      <h3 className="profile-name">{name}</h3>
    </Link>
  );
};

export default ProfileCard;
